<template>
  <PageWrapper :isLoading="isLoading" hasFilters @submitFilters="setFilters">
    <template #title> جزئیات اهداف کاربر ها </template>
    <template #filters>
      <SearchInput
        class="filters-width w-24"
        inputId="fullName"
        inputLabel="جستجوی نام کاربر"
        inputPlaceholder="رضا..."
        v-model.trim="getUserGoalsFilters.fullName"
        @enter="setFilters"
      ></SearchInput>
      <SearchInput
        class="filters-width w-24"
        inputId="mobile"
        inputLabel="جستجوی شماره کاربر"
        inputPlaceholder="0912..."
        v-model.trim="getUserGoalsFilters.mobile"
        @enter="setFilters"
      ></SearchInput>
      <GoalPicker
        class="filters-width w-24"
        v-model="getUserGoalsFilters.goal"
      ></GoalPicker>
      <CustomDatePicker
        class="filters-width w-24"
        inputId="userBirthDate"
        @getSelectedDate="setBirthdateFilter"
        :value="getUserGoalsFilters.birthDayDate"
        inputLabel="تاریخ تولد کاربر"
        inputPlaceholder="1403/06/05"
      >
      </CustomDatePicker>
      <HowToIntroducePicker
        class="filters-width w-24"
        v-model="getUserGoalsFilters.howToIntroduce"
      ></HowToIntroducePicker>

      <GenderPicker
        class="filters-width w-24"
        v-model="getUserGoalsFilters.sexuality"
      ></GenderPicker>
    </template>
    <CustomTable
      v-if="usersList"
      :pageNumber="getUserGoalsFilters.pageNumber"
      :count="getUserGoalsFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="usersList"
      @changePage="changePage"
    >
      <template #index="data">
        {{
          Math.ceil(
            data.index +
              1 +
              (getUserGoalsFilters.pageNumber - 1) * getUserGoalsFilters.count
          )
        }}
      </template>
      <template #fullName="data">
        <b-link :to="`/users/${data.item.id}`" dir="rtl">
          {{ data.item.fullName ? data.item.fullName : "-" }}
        </b-link>
      </template>

      <template #phoneNumber="data">
        <b-link :to="`/users/${data.item.id}`" dir="rtl">
          {{ data.item.phoneNumber }}
        </b-link>
      </template>

      <template #birthDayDate="data">
        {{
          data.item.birthDayDate
            ? new Date(data.item.birthDayDate).toLocaleDateString("fa-IR")
            : "-"
        }}
      </template>

      <template #createAt="data">
        {{
          data.item.createAt
            ? new Date(data.item.createAt).toLocaleDateString("fa-IR")
            : "-"
        }}
      </template>
    </CustomTable>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getUsersGoalsList();
  },
  data() {
    return {
      isLoading: false,
      getUserGoalsFilters: {
        pageNumber: 1,
        count: 10,
        fullName: null,
        mobile: null,
        goal: null,
        howToIntroduce: null,
        birthDayDate: null,
        sexuality: null,
      },
      usersList: null,
      totalCount: null,
      tableColumns: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "fullName",
          label: "نام",
        },
        {
          key: "phoneNumber",
          label: "شماره همراه",
        },
        {
          key: "goal",
          label: "اهداف",
          formatter: (val) => (val ? val : "-"),
        },
        {
          key: "howToIntroduce",
          label: "نحوه آشنایی",
          formatter: (val) => (val ? val : "-"),
        },
        {
          key: "sexuallity",
          label: "جنسیت",
          formatter: (val) => this.genderTypes[val],
        },
        {
          key: "birthDayDate",
          label: "تاریخ تولد",
        },
        {
          key: "createAt",
          label: "تاریخ عضویت",
        },
      ],
      genderTypes: {
        0: "وارد نشده",
        1: "زن",
        2: "مرد",
      },
    };
  },
  methods: {
    setBirthdateFilter(date) {
      if (date) {
        this.getUserGoalsFilters.birthDayDate = new Date(date).toISOString();
      } else {
        this.getUserGoalsFilters.birthDayDate = null;
      }
    },
    setPageNumberQuery(pageNumber) {
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: pageNumber,
        },
      });
    },
    changePage(val) {
      this.getUserGoalsFilters.pageNumber = val;
      this.setPageNumberQuery(val);
      this.getUsersGoalsList();
    },
    setFilters() {
      this.getUserGoalsFilters.pageNumber = 1;
      this.getUsersGoalsList();
    },
    async getUsersGoalsList() {
      try {
        this.isLoading = true;
        const _this = this;
        const getUsersByGoalAndBirthDate = new GetUsersByGoalAndBirthDate(
          _this
        );
        getUsersByGoalAndBirthDate.setRequestParam(_this.getUserGoalsFilters);
        await getUsersByGoalAndBirthDate.fetch((res) => {
          if (res.isSuccess) {
            _this.usersList = res.data.data;
            _this.totalCount = res.data.totalCount;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    PageWrapper,
    GoalPicker,
    SearchInput,
    CustomDatePicker,
    GenderPicker,
    HowToIntroducePicker,
    CustomTable,
    BLink,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomDatePicker from "@/views/components/Utils/CustomDatePicker.vue";
import GoalPicker from "@/views/components/Users/GoalPicker.vue";
import HowToIntroducePicker from "@/views/components/Users/HowToIntroducePicker.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import GenderPicker from "@/views/components/Users/GenderPicker.vue";
import { BLink } from "bootstrap-vue";
import { GetUsersByGoalAndBirthDate } from "@/libs/Api/Users";
</script>
